"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var iconNames = ['delete-24', 'edit-24', 'plus', 'view', 'export', 'delete-12', 'arrow-down', 'close', 'video', 'close-circle', 'warning-48', 'edit-12', 'drag-12', 'info', 'clock', 'arrowright-line', 'check', 'calendar', 'arrowbottom-line', 'share', 'view-fill', 'view-fill-22', 'viewlist', 'arrowright-24', 'pencile', 'playback-12', 'soon-12', 'more-24', 'more', 'edit-line-24', 'view-24', 'meeting-small', 'meeting-large'];
var _default = iconNames;
exports.default = _default;